module.exports = __webpack_public_path__ + "static/media/ticket-logo-banesco.8612db6d.svg";